// extracted by mini-css-extract-plugin
module.exports = {"tipText":"activity-detail_tipText_1ktRG"};